module.exports = __webpack_public_path__ + "img/logo.cc19f91d.svg";